import type { SVGProps } from 'react';

export default function MoneyBagIcon({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        transform="translate(2 2)"
        d="M6 8.46667C5.69256 8.46667 5.43239 8.35833 5.2195 8.14167C5.0065 7.925 4.9 7.66294 4.9 7.3555C4.9 7.04817 5.0065 6.78617 5.2195 6.5695C5.43239 6.35283 5.69256 6.2445 6 6.2445C6.31478 6.2445 6.5805 6.35283 6.79717 6.5695C7.01383 6.78617 7.12217 7.04817 7.12217 7.3555C7.12217 7.66294 7.01383 7.925 6.79717 8.14167C6.5805 8.35833 6.31478 8.46667 6 8.46667ZM3.07217 2.72217H8.95L10.3055 0H1.7055L3.07217 2.72217ZM3.5555 12H8.4555C9.44072 12 10.2796 11.6546 10.9722 10.9638C11.6648 10.2732 12.0112 9.43339 12.0112 8.4445C12.0037 8.02228 11.9296 7.61672 11.7888 7.22783C11.6482 6.83894 11.4445 6.48339 11.1778 6.16117L9.2445 3.83333H2.76667L0.822167 6.16117C0.562945 6.48339 0.361111 6.83894 0.216667 7.22783C0.0722222 7.61672 0 8.02228 0 8.4445C0 9.43339 0.345389 10.2732 1.03617 10.9638C1.72683 11.6546 2.56661 12 3.5555 12Z"
      />
    </svg>
  );
}
